const store = {
  state: {
    requests: [
      {nick: 'nick1', pid: 'pid1', state: 'W', time: new Date()},
      {pid: 'pid2', state: 'A', time: new Date()}
    ],
    searchResults: []
  },
  getters: {
    sortedRequests: state => {
      return state.requests.sort(function(a, b) {return a.time < b.time})
    },
    sortedSearchResults: state => {
      var resNicks = []
      var resPids = []
      state.searchResults.forEach(res => {
        if (res.nick) {
            resNicks.push(res)
        } else {
            resPids.push(res)
        }
      })
      resNicks = resNicks.sort(function (a,b) {return a.nick.toLowerCase() > b.nick.toLowerCase()})
      resPids = resPids.sort(function (a,b) {return a.pid.toLowerCase() > b.pid.toLowerCase()})
      return resNicks.concat(resPids)
    }
  },
  mutations: {
  },
  actions: {
    async loadRequests({dispatch, state}) {
      var res = await dispatch('get', {url: '/api/requests/load'})
      state.requests = res.data
    },
    async search({dispatch, state}, query) {
      var res = await dispatch('post', {url: '/api/requests/search', data: {query: query}})
      state.searchResults = res.data
    },
    async clearSearch({state}) {
      state.searchResults = []
    },
    async sendRequest({dispatch}, data) {
       // state.requests.push({nick: data.nick, pid: data.pid, state: 'W', time: new Date()})
      await dispatch('post', {url: '/api/requests/send', data: {peer: data.pid, time: new Date()}})
      await dispatch('loadRequests')
    },
    async approveRequest({dispatch}, pid) {
      await dispatch('post', {url: '/api/requests/process', data: {peer: pid, action: 'approve'}})
      await dispatch('loadRequests')
    },
    async deleteRequest({dispatch}, pid) {
      await dispatch('post', {url: '/api/requests/process', data: {peer: pid, action: 'remove'}})
      await dispatch('loadRequests')
    }
  }
}
export default store
